/**
 * Tax rate conversions between the UI (percent, "8.5") and the API
 * (Decimal(5,4) fraction, "0.0850").
 */

// Up to 3 integer digits and 2 decimals: 2 percent decimals = the 4 fraction
// decimals the backend Decimal(5,4) column can hold.
const PERCENT_PATTERN = /^\d{1,3}(\.\d{1,2})?$/;

/** "0.0850" -> "8.5" (no float noise, no trailing zeros). */
export function rateToPercentString(rate: string | number): string {
  const n = Number(rate);
  if (!Number.isFinite(n)) return String(rate);
  return String(Number((n * 100).toFixed(4)));
}

/** "0.0850" -> "8.5%" */
export function formatRatePercent(rate: string | number): string {
  return `${rateToPercentString(rate)}%`;
}

/** "8.5" -> "0.0850", or null when the input is not a valid 0-100 percentage. */
export function percentToRate(percent: string): string | null {
  const trimmed = percent.trim();
  if (!PERCENT_PATTERN.test(trimmed)) return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n < 0 || n > 100) return null;
  return (n / 100).toFixed(4);
}
